import React, { Component } from 'react';


class Demo extends Component {
    render() {
        return (
            <div className="page-header py-4 no-gutters row">
                <div className="text-sm-left mb-3 text-center text-md-left mb-sm-0 col-12 col-sm-4">
                    <span
                        className="text-uppercase page-subtitle">Escritorio ejemplo
                    </span>
                    <h3 className="page-title">Titulo secundario</h3>
                </div>
            </div>
        );
    }
}

export default Demo;
